import React, { useEffect } from 'react'
import Navbar from '../../components/Navbar'
// import success from '../../assets/success.svg'
import SmallFooter from '../../components/SmallFooter'
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const OrderHistory = () => {
    const [orders, setOrders] = React.useState([])
    const [isLoading, setIsLoading] = React.useState(true)


    const notify = (text) => toast(text, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
    });

    const takeRating = (rating, productId, orderId) => {
        console.log(rating, productId, orderId)
        try {
            fetch(process.env.REACT_APP_SERVER_URL + '/orders/addRating', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + localStorage.getItem('token')
                },
                body: JSON.stringify({
                    rating,
                    productId,
                    orderId
                })
            })
                .then(res => res.json())
                .then(data => {
                    console.log(data)
                    notify(data.message)
                    getAllOrders()
                }
                ).catch(err => {
                    notify(err.message)
                })
        } catch (err) {
            console.log(err)
        }
    }
    const getAllOrders = () => {
        try {
            fetch(process.env.REACT_APP_SERVER_URL + '/orders/getOrder', {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + localStorage.getItem('token')
                }
            })
                .then(res => res.json())
                .then(data => {
                    console.log(data.orders)
                    setOrders(data.orders)
                    setIsLoading(false)
                }
                )
                .catch(err => console.log(err))
        } catch (error) {
            console.log(error)
        }
    }

    useEffect(() => {
        getAllOrders()
    }, [])

    const addToCart = (id) => {
        if (localStorage.getItem('token') === null) {
            window.location.href = '/login'
        }

        try {
            fetch(process.env.REACT_APP_SERVER_URL + '/cart/addtocart', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + localStorage.getItem('token')
                },
                body: JSON.stringify({
                    productId: id
                })
            })
                .then(res => res.json())
                .then(data => {
                    notify(data.message)
                }
                ).catch(err => {
                    notify(err.message)
                })
        } catch (err) {
            notify(err)
            // console.log(err)
        }
    }

    useEffect(() => {
        console.log(orders)
    }, [orders])

    return (
        <div className=''>
            <Navbar />
            <div>
                <ToastContainer className='mt-20' />
            </div>
            <div className=' mx-2 lg:mx-32 mt-20 flex flex-col space-y-10'>
                <div>
                    <h1 className='text-xl md:text-2xl'>Order History</h1>
                    <p className='text-gray-600 text-sm'>All your previous orders are shown here.</p>
                </div>

                {isLoading ? <>
                    {/* tailwind loader */}
                    <div className="flex justify-center items-center h-screen">
                        <div className="animate-spin rounded-full h-32 w-32 border-b-2 border-gray-900"></div>
                    </div>

                </> : orders.length > 0 && orders.map((order) => (

                    <div className='border border-gray-400 rounded-lg p-5' key={order._id}>
                        <div className='flex flex-col lg:flex-row justify-between space-y-2 items-center'>
                            <div className='flex flex-col md:flex-row space-y-2 md:space-x-8'>
                                <div className='flex flex-col'>
                                    <p className='text-lg'>Order Number</p>
                                    <p className='text-sm text-gray-600'>{order._id}</p>
                                </div>
                                <div className='flex flex-col'>
                                    <p className='text-lg'>Order Date</p>
                                    <p className='text-sm text-gray-600'>{order.order_date}</p>
                                </div>
                                <div className='flex flex-col'>
                                    <p className='text-lg'>Total Ammount</p>
                                    <p className='text-sm text-gray-600'>₹ {order.total}</p>
                                </div>
                                <div className='flex flex-col'>
                                    <p className='text-lg'>Address</p>
                                    <p className='text-sm md:truncate text-gray-600 w-40 lg:w-80'>{order.address}</p>
                                </div>
                                <div className='flex flex-col'>
                                    <p className='text-lg'>Payment Method</p>
                                    <p className='text-sm text-gray-600'>{order.paymentMethod}</p>
                                </div>
                            </div>
                            <div className='cursor-pointer group' onClick={() => {
                                window.open(`/invoice/${order._id}`, 'invoice', 'width=780, height=800 ,status=1, scrollbars=1, location=0,resizable=yes')
                            }}>
                                <p className='border border-gray-400 p-2 rounded-xl group-hover:text-green-600'>View Invoice</p>
                            </div>
                        </div>
                        {order.products.map((item) => (

                            <div className='flex flex-col space-y-5 mt-10' key={item._id}>
                                <hr className='mb-2' />
                                <div className='flex space-x-5'>
                                    <div className='flex-none'>
                                        <img src={item.imgUrl || 'https://dummyimage.com/2:3x900/'} alt='item' className='h-20 w-20 md:h-52 md:w-52 object-cover' />
                                    </div>
                                    <div className='flex flex-col space-y-5'>
                                        <div className='flex flex-col justify-between'>
                                            <p className='text-base md:text-2xl'>{item.name}</p>
                                            <p className='text-sm md:text-xl'>₹ {item.price}</p>
                                        </div>
                                        <div><p>{item.descrciption}</p></div>
                                        <div className="flex items-center">
                                            {
                                                item.rating > 0 ?
                                                    <>
                                                        {

                                                            Array(item.rating).fill().map((_, i) => (
                                                                <svg key={i} aria-hidden="true" className="w-5 h-5 text-yellow-400 cursor-pointer" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"
                                                                    onClick={() => {
                                                                        takeRating(i + 1, item.product, order._id)
                                                                    }
                                                                    }><title>{i + 1} star</title><path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z"></path></svg>
                                                            ))
                                                        }
                                                        {
                                                            Array(5 - item.rating).fill().map((_, i) => (
                                                                <svg key={i} aria-hidden="true" className="w-5 h-5 cursor-pointer text-gray-300 " fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"
                                                                    onClick={() => {
                                                                        takeRating(5 - i, item.product, order._id)

                                                                    }
                                                                    }
                                                                ><title>{5 - i} star</title><path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z"></path></svg>
                                                            ))}
                                                    </>

                                                    :

                                                    // 5 loop for empty 5 stars
                                                    [1, 2, 3, 4, 5].map((_, index) => (
                                                        <svg key={index} aria-hidden="true" className="w-5 h-5 text-gray-300 dark:text-gray-500 cursor-pointer" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"
                                                            onClick={() => {
                                                                takeRating(index + 1, item.product, order._id)

                                                            }
                                                            }
                                                        ><title>{index + 1} star</title><path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z"></path></svg>
                                                    ))
                                            }

                                        </div>
                                    </div>
                                </div>

                                <div className='flex flex-col md:flex-row space-y-3 justify-between items-center text-center'>
                                    <div className='flex space-x-3 justify-center items-center'>

                                        <p>{order.status} on {order.status_date}</p>
                                    </div>
                                    <div className=''>
                                        <a target="_blank" href={`/dp/${item.product}`} rel="noreferrer" alt='...' className='text-blue-600 pr-3 border-r border-gray-400'>View product</a>
                                        <button onClick={() => { addToCart(item.product) }} alt='...' className='text-blue-600 pl-3'>Buy again</button>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                ))}

            </div>
            <div className='relative'></div>
            <SmallFooter />
        </div>
    )
}

export default OrderHistory